module.exports = __webpack_public_path__ + "img/face-shush.1cb2a79a.svg";